export const TRUSTPILOT_HARDCODE_RATINGS = true;
